// Mini Cart Toggle
function toggleCart(open) {
  document.getElementById('cartDrawer').classList.toggle('open', open);
  document.getElementById('cartOverlay').classList.toggle('open', open);
  if (open) document.body.style.overflow = 'hidden';
  else document.body.style.overflow = '';
}

// Format money (cents -> NZD string e.g. "$12.99")
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Rebuild the cart drawer body from live /cart.js data
function refreshCartDrawer() {
  return fetch('/cart.js?_=' + Date.now())
    .then(r => r.json())
    .then(cart => {
      var freeShippingCents = 79 * 100; // matches settings.free_shipping_threshold
      var remaining = freeShippingCents - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price / freeShippingCents * 100));

      // Update cart count badge
      var el = document.getElementById('cartCount');
      if (el) el.textContent = cart.item_count;

      // Update subtotal
      var subtotalEl = document.getElementById('cartSubtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      // Rebuild threshold bar
      var thresholdEl = document.querySelector('.cart-threshold');
      if (thresholdEl) {
        if (cart.total_price >= freeShippingCents) {
          thresholdEl.innerHTML = '<p class="threshold-msg">🎉 <strong>You\'ve unlocked free delivery!</strong></p><div class="threshold-bar-wrap"><div class="threshold-bar" style="width:100%"></div></div>';
        } else {
          thresholdEl.innerHTML = '<p class="threshold-msg">Add <strong>' + formatMoney(remaining) + '</strong> more for free delivery</p><div class="threshold-bar-wrap"><div class="threshold-bar" style="width:' + pct + '%"></div></div>';
        }
      }

      // Rebuild cart body items
      var bodyEl = document.getElementById('cartBody');
      if (!bodyEl) return;

      if (cart.item_count === 0) {
        bodyEl.innerHTML = (thresholdEl ? '' : '') + '<p style="text-align:center;padding:40px 0;color:var(--text-light)">Your cart is empty.</p>';
        // Keep threshold inside body if that's where it lives
        if (thresholdEl && bodyEl.contains(thresholdEl)) {
          bodyEl.insertAdjacentHTML('afterbegin', thresholdEl.outerHTML);
        }
        return;
      }

      var itemsHTML = cart.items.map(function(item) {
        var imgHTML = item.image
          ? '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="56" height="56" style="object-fit:cover;border-radius:var(--r)">'
          : '<svg viewBox="0 0 24 24" width="28" height="28" fill="var(--red)" opacity=".3" aria-hidden="true"><path d="M8.35 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm7.3 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM4 9.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm16 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM12 11c3.87 0 7 3.13 7 7 0 2-1.5 3.5-3.5 3.5h-7C6.5 21.5 5 20 5 18c0-3.87 3.13-7 7-7z"/></svg>';

        var variantHTML = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p style="font-size:12px;color:var(--text-light)">' + item.variant_title + '</p>'
          : '';

        var key = item.key;
        return '<div class="cart-item">' +
          '<div class="cart-item-img">' + imgHTML + '</div>' +
          '<div class="cart-item-info">' +
            '<p class="cart-item-name">' + item.product_title + '</p>' +
            variantHTML +
            '<div style="display:flex;align-items:center;gap:12px;margin-top:4px">' +
              '<div class="qty-ctrl qty-ctrl--sm">' +
                '<button onclick="updateCartItem(\'' + key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button onclick="updateCartItem(\'' + key + '\',' + (item.quantity + 1) + ')" aria-label="Increase">+</button>' +
              '</div>' +
              '<p class="cart-item-price">' + formatMoney(item.line_price) + '</p>' +
            '</div>' +
          '</div>' +
          '<button onclick="updateCartItem(\'' + key + '\',0)" style="background:none;border:none;color:var(--text-light);font-size:16px;cursor:pointer;padding:4px" aria-label="Remove">✕</button>' +
        '</div>';
      }).join('');

      // Preserve threshold bar at top of body, then inject items
      var thresholdHTML = thresholdEl ? thresholdEl.outerHTML : '';
      bodyEl.innerHTML = thresholdHTML + itemsHTML;
    })
    .catch(function() { location.reload(); });
}

// Add to cart
function addToCart(variantId, qty) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    toggleCart(true);
    return refreshCartDrawer();
  })
  .catch(function() { location.reload(); });
}

// Cart AJAX update (qty change / remove)
function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    return refreshCartDrawer();
  })
  .catch(function() { location.reload(); });
}

// Mobile nav + ESC
document.addEventListener('DOMContentLoaded', function() {
  var mNav = document.getElementById('mNav');
  if (mNav) {
    mNav.addEventListener('click', function(e) {
      if (e.target === this) this.classList.remove('open');
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') toggleCart(false);
  });
});
